import type { BackendApiErrorUnion } from '@vs-shop/engine/data/error/backendApi/_internal/createBackendApiError';
import type { BrandAlphabetAdapters } from '@vs-shop/engine/module/brand/brandAdapters';
import { makeBrandModule } from '@vs-shop/engine/module/brand/makeBrandModule';
import { BrandAlphabet, BrandIndex } from '../schema/openapi/backend';
import type { StripJsonLd } from '@vs-shop/schemas/transform/withoutJsonLd';

/**
 * Seam-C tenant bind (workspace#49 option C, layer 3).
 *
 * Instantiates the engine brand module with rcprofi's `BrandAlphabet` /
 * `BrandIndex` schemas at module scope. Re-exports the record's members
 * under their pre-seam names so `brand/getBrandsAlphabet.ts` and
 * `brand/getBrands.ts` callers repoint here with an import-line-only change.
 */

const brandAlphabetAdapters: BrandAlphabetAdapters<StripJsonLd<BrandAlphabet>> = {
  letters: (brandAlphabet) => brandAlphabet.alphabet,
};

const brandModule = makeBrandModule({
  brandAlphabet: BrandAlphabet,
  brandAlphabetAdapters,
  brandIndex: BrandIndex,
});

export const listBrandsAlphabet = brandModule.listBrandsAlphabet();
export type BrandListAlphabetError = BackendApiErrorUnion<
  typeof brandModule.ListBrandsAlphabetError
>;

export const requestBrands = brandModule.requestBrands;
export type BrandListError = BackendApiErrorUnion<typeof brandModule.ListBrandsError>;
